import HouseIcon from './HouseIcon';
export default HouseIcon;
